// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

export const UnitsRepository = {

    /*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the data
	*/

	data: () => ({

        new_unit: {
			id: null,
			type: 'property.unit',
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				version: 1
			},
			attributes: {
				available: true,
				number: null,
				square_feet: 0,
				bedrooms: 0,
				bathrooms: 0,
				description: null,
				features: [],
				rent: {
					current: 0,
					market: 0
				},
				address: {
					street_1: null,
					street_2: null,
					city: null,
					state: null,
					zip_code: null,
					country: 'US'
				},
				resident: {
					first_name: null,
					last_name: null
				}
			},
			metrics: null,
			links: {
				media: []
			},
			relationships: {
				property: null,
				user: firebaseAuth.currentUser.uid,
				lease: null,
				resident: null,
				stripe: {
					product: null,
					price: null
				}
			}
		}

    }),

    /*
	**  Set the methods
	*/

	methods: {

        resetNewUnitProp: function() {

			// Reset the prop
			this.new_unit = {
				id: null,
				type: 'property.unit',
				meta: {
					created_at: moment().unix(),
					updated_at: moment().unix(),
					deleted_at: null,
					app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
					version: 1
				},
				attributes: {
					available: true,
					number: null,
					square_feet: 0,
					bedrooms: 0,
					bathrooms: 0,
					description: null,
					features: [],
					rent: {
						current: 0,
						market: 0
					},
					address: {
						street_1: null,
						street_2: null,
						city: null,
						state: null,
						zip_code: null,
						country: 'US'
					},
					resident: {
						first_name: null,
						last_name: null
					}
				},
				links: null,
				relationships: {
					property: null,
					user: firebaseAuth.currentUser.uid,
					lease: null,
					resident: null,
					stripe: {
						product: null,
						price: null
					}
				}
			}

		}

    }

}